import { IConfigurations } from '@epicuro-next/platform/configuration';

export const BASKET_MANAGER_FEATURE_NAME = 'basket-manager';

export enum BasketManagerConfigurationKeys {
  IsGroupedView = 'is-basket-manager-grouped',
}

export interface BasketManagerConfigurations
  extends IConfigurations<BasketManagerConfigurationKeys> {
  [BasketManagerConfigurationKeys.IsGroupedView]: boolean;
}

export const DEFAULT_IS_GROUPED_VIEW = true;
